import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { NFTCollectionProvider } from './context/NFTCollectionContext';
import reportWebVitals from './reportWebVitals';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <NFTCollectionProvider>
      <App />
    </NFTCollectionProvider>
  </React.StrictMode>
);

reportWebVitals();
